/* Booster Drop cart page — minimal JS, preserves native cart form behavior.
   Quantity steppers mutate the matching `updates[<key>]` input and submit the
   form via the hidden `<button name="update">` so Shopify processes the update
   exactly as if the user clicked "Update cart". No AJAX. */
(function () {
  'use strict';

  // How long to wait after the last quantity change before reloading the cart.
  // Long enough to type a multi-digit quantity or tap a stepper several times
  // without the page reloading mid-edit.
  var SUBMIT_DELAY = 1000;

  function init() {
    var section = document.querySelector('[data-cb-section]');
    if (!section) return;

    var form = section.querySelector('[data-cb-form]');
    if (!form) return;

    var hiddenSubmit = section.querySelector('[data-cb-submit]');

    // Per-item clamp fns, run before submit so we never POST an over-stock qty.
    var clampers = [];

    var submitTimer = null;
    function scheduleSubmit() {
      clearTimeout(submitTimer);
      submitTimer = setTimeout(function () {
        clampers.forEach(function (fn) { fn(); });
        section.classList.add('is-busy');
        // Prefer clicking the hidden "update" button so Shopify sees a named
        // submit. Falls back to form.submit() if the button is missing.
        if (hiddenSubmit) {
          hiddenSubmit.click();
        } else {
          form.submit();
        }
      }, SUBMIT_DELAY);
    }

    section.querySelectorAll('[data-cb-item]').forEach(function (item) {
      var wrap  = item.querySelector('[data-cb-qty]');
      var input = item.querySelector('[data-cb-qty-input]');
      var dec   = item.querySelector('[data-cb-decrement]');
      var inc   = item.querySelector('[data-cb-increment]');
      var hint  = item.querySelector('[data-cb-qty-hint]');
      if (!input || !wrap) return;

      // -1 means no cap (untracked, or overselling is allowed for this variant).
      var max = parseInt(wrap.getAttribute('data-cb-max'), 10);
      if (isNaN(max)) max = -1;

      // Reflect stepper availability + the stock hint for the current value
      // without rewriting partial input. The hint is shown by clearing its
      // inline display:none (set in the template) so there's no load flash.
      function refreshControls() {
        var n = parseInt(input.value, 10);
        var hasValue = !isNaN(n);
        var atOrOverMax = max >= 0 && hasValue && n >= max;
        if (inc) inc.disabled = atOrOverMax;
        if (hint) hint.style.display = atOrOverMax ? '' : 'none';
        if (dec) dec.disabled = hasValue && n <= 0;
      }

      // Settle the field to a valid, in-stock integer. Used on commit + submit.
      function clampValue() {
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 0) n = 0;
        if (max >= 0 && n > max) n = max;
        input.value = n;
        refreshControls();
      }
      clampers.push(clampValue);

      refreshControls();

      if (dec) dec.addEventListener('click', function () {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        refreshControls();
        scheduleSubmit();
      });
      if (inc) inc.addEventListener('click', function () {
        var n = (parseInt(input.value, 10) || 0) + 1;
        if (max >= 0 && n > max) n = max;
        input.value = n;
        refreshControls();
        scheduleSubmit();
      });

      // While typing: allow multi-digit entry, but never let the value exceed
      // available stock — anything over the cap snaps straight to the max.
      input.addEventListener('input', function () {
        var n = parseInt(input.value, 10);
        if (!isNaN(n) && max >= 0 && n > max) input.value = max;
        refreshControls();
        scheduleSubmit();
      });

      // On commit (blur / Enter): settle to a valid value before the cart reloads.
      input.addEventListener('change', function () {
        clampValue();
        scheduleSubmit();
      });
    });

    // Remove links use the native /cart/change?line=N&quantity=0 URL — no JS needed.
    section.querySelectorAll('[data-cb-remove]').forEach(function (link) {
      link.addEventListener('click', function () {
        section.classList.add('is-busy');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-cb-section]')) init();
  });
})();
